<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-light" style="
            height: 58px;
        ">
        <button type="button" id="sidebarCollapse" class="btn">
            <i class="fas fa-bars"></i>
        </button>
        <a class="navbar-brand genericName" href="#">Preventb Tb</a>
        <!-- <p>{{ $t("message.hello") }}</p> -->
        <a class="profile_link">
            <i class="fa fa-exclamation-circle pr-1" title="Disclaimer" style="color: #ca0808;" v-b-modal.modal-global></i>
            <i class="fa fa-language navIconStyle pr-1" ></i>
            <select class="custom-select custom-select-sm mr-1" v-model="$root.localLang" @change="langChange()">
                <option :value="langid"  v-for="(lang,langid) in userData.programlocales" :key="langid">{{lang}}</option>
            </select>
            <!-- <h5 class="disclimer text-center"></h5> -->
            <div class="">
                <a class="logout navIconStyle btn pull-right " style="padding: 17px 10px;">
                    <i @click="logOut()" class="fas fa-sign-out-alt pull-right"></i>
                </a>
            </div>
        </a>
    </nav>
    <b-modal size="md" id="modal-global" hide-footer>
        <template v-slot:modal-title> {{ $t("Disclaimer.disclaimer") }} </template>
        <div class="modal-body">
            {{message}}
            <!-- {{disclimerLocal[$root.localLang]}} ? {{disclimerLocal[$root.localLang]}} : {{disclimerLocal['en']}} -->
        </div>
    </b-modal>
</div>
</template>

<style scoped>
.pull-right {
    float: right !important;
}
</style>

<script>
export default {
    data() {
        return {
            userData: JSON.parse(sessionStorage.getItem("userData")),
            programName: '',
            message: '',
            disclimerLocal :JSON.parse(sessionStorage.getItem("disclaimerLocal")),
        }
    },
    methods: {
        logOut() {
            sessionStorage.removeItem('userData')
            this.$router.push('/')
        },
        langChange(){
            // console.log(this.$root.localLang)
            this.$i18n.locale = this.$root.localLang
            if(this.disclimerLocal[this.$root.localLang] != ''){
                this.message = this.disclimerLocal[this.$root.localLang]
            }else{
                this.message = this.disclimerLocal['en']
            }
        }
    },
    mounted() {
        let langLocal = JSON.parse(sessionStorage.getItem('langLocal'))
        for(let lang in langLocal){
            console.log(lang, langLocal[lang])
            this.$i18n.setLocaleMessage(lang,langLocal[lang])
        }
        this.programName = this.userData.programname
        // this.message = this.disclimerLocal[this.$root.localLang]
    }
}
</script>
